import React from 'react';
import MuiAlert from '@mui/material/Alert';
import { MdClose } from 'react-icons/md';
import Table from 'src/components/VehicleTrackingDetails/Tables/Table';
import CustomMultiSelect from 'src/utils/CustomMultiSelect';

export default function GoodsReceivedNotesDesktop({ toggleGrnDrawer, logic }) {
  const {
    formData,
    themeColor,
    vehicleTrackingLineItemList,
    getStorageLocationOptionsForPlant,
    handleCheckboxClick,
    handleOnChange,
    handleSubmit,
    invalidFormSubmission,
    setInvalidFormSubmission,
  } = logic;

  const headers = [
    { value: 'plant', label: 'Plant' },
    { value: 'purchase_order', label: 'Purchase Order' },
    { value: 'material_code', label: 'PO Line Item' },
    { value: 'receiving_quantity', label: 'Quantity' },
    { value: 'storage_location', label: 'Storage Location' },
    { value: 'batch', label: 'Batch' },
  ];

  const renderTableContent = () => (
    <tbody>
      {vehicleTrackingLineItemList?.length ? (
        vehicleTrackingLineItemList.map((itemObj) => (
          <tr key={itemObj.id}>
            {headers.map((header) => {
              const key = header.value;

              if (key === 'select') {
                return (
                  <td key={key}>
                    <input
                      type="checkbox"
                      checked={formData[itemObj.id]?.active || false}
                      onChange={(e) =>
                        handleCheckboxClick(itemObj, e.target.checked)
                      }
                    />
                  </td>
                );
              }

              if (key === 'plant') {
                return (
                  <td key={key}>
                    <input
                      type="checkbox"
                      checked={formData[itemObj.id]?.active || false}
                      onChange={(e) =>
                        handleCheckboxClick(itemObj, e.target.checked)
                      }
                    />
                    <span className="text-sm">
                      {' '}
                      {itemObj?.plant?.plant_code}
                    </span>
                  </td>
                );
              }

              if (key === 'purchase_order') {
                return (
                  <td key={key}>
                    <span className="text-sm">
                      {itemObj?.purchase_order_number}
                    </span>
                  </td>
                );
              }

              if (key === 'material_code') {
                return (
                  <td key={key}>
                    <span className="text-sm">{itemObj?.material_code}</span>
                  </td>
                );
              }

              if (key === 'receiving_quantity') {
                return (
                  <td key={key}>
                    <span className="text-sm">
                      {itemObj?.receiving_quantity}{' '}
                      {itemObj?.unit_of_measurement}
                    </span>
                  </td>
                );
              }

              if (key === 'storage_location') {
                return (
                  <td key={key}>
                    <div className="input-wrapper">
                      <CustomMultiSelect
                        name="storage_location_id"
                        isMulti={false}
                        className="multi-select-input-section"
                        onChange={(selectedOption) => {
                          handleOnChange(
                            {
                              target: {
                                name: 'storage_location_id',
                                value: selectedOption?.value || null,
                              },
                            },
                            itemObj.id,
                          );
                        }}
                        options={getStorageLocationOptionsForPlant(
                          itemObj.plant.id,
                        )}
                        placeholder="Select Storage Location"
                        value={getStorageLocationOptionsForPlant(
                          itemObj.plant.id,
                        ).find(
                          (opt) =>
                            opt.value ===
                            formData[itemObj.id]?.storage_location_id,
                        )}
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          menu: (base) => ({ ...base, width: '250px' }),
                          control: (base) => ({ ...base, width: '100%' }),
                        }}
                      />
                    </div>
                  </td>
                );
              }

              if (key === 'batch') {
                return (
                  <td key={key}>
                    <input
                      className="form-input-section"
                      name="batch_number"
                      type="text"
                      value={formData[itemObj.id]?.batch_number || ''}
                      onChange={(e) => handleOnChange(e, itemObj.id)}
                    />
                  </td>
                );
              }

              return <td key={key}>{itemObj?.[key] ?? '-'}</td>;
            })}
          </tr>
        ))
      ) : (
        <tr>
          <td colSpan={headers.length}>
            <span>No Items Available</span>
          </td>
        </tr>
      )}
    </tbody>
  );

  return (
    <div className="page-layout div-flex-column right-form-layout">
      <div className="div-flex-row div-space-between div-align-center border-bottom drawer-section-padding">
        <div className="div-space-between slider-padding">
          <span className="text-xxl text-bold">
            Goods Receipt: Select Line Items & Storage
          </span>
        </div>
        <button
          className="icon-btn-none"
          onClick={() => toggleGrnDrawer(false)}
          aria-label="Close drawer"
        >
          <MdClose size="24px" />
        </button>
      </div>

      {invalidFormSubmission && (
        <MuiAlert
          onClose={() => setInvalidFormSubmission(false)}
          severity="error"
          elevation={6}
          variant="filled"
        >
          Please select a Storage Location for all selected items.
        </MuiAlert>
      )}

      <div
        className={`main-vehicle-tracking-detail-form-container theme-scrollable-container-${themeColor}`}
      >
        <div className="form-line-item-container top-padding">
          <div
            className={`table-fixed-container theme-horizontal-scrollable-container-${themeColor}`}
          >
            <Table
              headers={headers}
              minCellWidth={100}
              tableContent={renderTableContent()}
            />
          </div>
        </div>
      </div>

      <div className="footer-container footer-padding">
        <div className="div-space-between div-align-center footer-content-for-page">
          <div></div>
          <button
            type="button"
            className={`vehicle-tracking-detail-move-stage-btn theme-background-${themeColor}`}
            onClick={handleSubmit}
          >
            <span className="text-md">Submit GRN</span>
          </button>
        </div>
      </div>
    </div>
  );
}
